export default function truthyQueryParameter(parameter) {
  return /^(true|1)$/.test(parameter);
}
